import React, { useEffect, useState } from 'react';
// import QRCode, { QRCodeSVG } from 'qrcode.react';
import { Autocomplete, Box, Button, Paper, TextField, Typography } from '@mui/material';

const UpiTextField = ({ disable }) => {
    const [amount, setAmount] = useState('');
    const [upiUrl, setUpiUrl] = useState('');
    const upiHandles = [
        "sbi",
        "oksbi",
        "hdfcbank",
        "icici",
        "axisbank",
        "pnb",
        "barodapay",
        "cnrb",
        "unionbankofindia",
        "yesbank",
        "kotak",
        "idfcfirstbank",
        "indus",
        "federal",
        "rbl",
        // Note: Google Pay uses partner banks' handles
        "okhdfcbank",
        "okicici",
        "okaxis",
        // Note: PhonePe uses Yes Bank's handle
        "ybl",
        "paytm",
        // Note: Amazon Pay is usually associated with Axis Bank or ICICI Bank for UPI transactions
        "apl"
    ]

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const [inputValue, setinputValue] = useState('');
    const handleInputChange = (event, newInputValue) => {
        setinputValue(newInputValue);
    };

    const getSuggestions = () => {
        if (!inputValue.includes('@')) {
            return [];
        }
        const searchTerm = inputValue.slice(inputValue.indexOf('@') + 1);
        return upiHandles
            .filter(handle => handle.includes(searchTerm))
            .map(handle => inputValue.slice(0, inputValue.indexOf('@') + 1) + handle);
    };

    const handleGenerateQRCode = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const paymentAddress = encodeURIComponent(inputValue);
            const constructedUpiUrl = `upi://pay?pa=${paymentAddress}&am=${amount}`;
            setUpiUrl(constructedUpiUrl);
            console.log(constructedUpiUrl)
        } catch (error) {
            console.log(error)
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => { console.log(upiUrl) }, [upiUrl])
    return (
        <>
            <Box
                sx={{
                    paddingTop: "90px",
                    paddingLeft: { xs: "8px", sm: "70px", lg: "80px" },
                    paddingRight: { xs: "8px", lg: "30px" },
                    paddingBottom: "8px",
                    boxSizing: "content-box",
                }}
            >
                <Box
                    sx={{
                        minHeight: "550px",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "background.paper",
                            borderRadius: "8px",
                            boxShadow:
                                "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
                            ":hover": {
                                boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
                            },
                            transition: "all 1s ease-in-out",
                            padding: 2
                        }}
                    >
                        <Autocomplete
                            size="small"
                            options={getSuggestions()}
                            disabled={disable}
                            inputValue={inputValue}
                            onInputChange={handleInputChange}
                            renderInput={(params) => (
                                <TextField {...params} label="UPI" variant="outlined"
                                    sx={{
                                        ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                                            fontSize: "14px",
                                        },
                                        label: {
                                            fontSize: "14px",
                                        },
                                        ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                                            fontSize: "14px",
                                        },
                                        '.css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root': {
                                            color: 'input.font'
                                        },
                                        ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                            borderColor: "input.border",
                                        },
                                        ".css-14qz1ij-MuiListItemText-root": {
                                            margin: "0px",
                                        },
                                        ".css-wgai2y-MuiFormLabel-asterisk": {
                                            color: "danger.main",
                                        },
                                    }} />
                            )}
                            freeSolo
                            onBlur={() => handleGenerateQRCode}
                        />
                        <TextField
                            size='small'
                            type="number"
                            id="amount"
                            label="Amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                        <Button
                            variant='contained'
                            onClick={handleGenerateQRCode} disabled={isLoading}>
                            {isLoading ? 'Generating QR Code...' : 'Generate QR Code'}
                        </Button>
                        <br />
                        {error && <p className="error">{error.message}</p>}
                        {/* {upiUrl && <QRCode value={upiUrl} size={256} />} */}
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default UpiTextField;